import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { useSelector } from 'react-redux';

import { filterShape } from 'app/shapes/search';
import ExpandedFiltersOverlay from './ExpandedFiltersOverlay';

const ExpandedFiltersOverlayContainer = ({ fieldId, filters, handleClose, handleToggleExpandedField, label, open }) => {
  const isFetching = useSelector(state => {
    return (
      (state.getIn(['search', 'catalogSearch', 'isFetching']) ?? false) ||
      (state.getIn(['search', 'catalogSearch', 'isFetchingShowMoreFilters']) ?? false)
    );
  });

  return (
    <ExpandedFiltersOverlay
      fieldId={fieldId}
      filters={filters}
      handleClose={handleClose}
      handleToggleExpandedField={handleToggleExpandedField}
      isFetching={isFetching}
      label={label}
      open={open}
    />
  );
};

ExpandedFiltersOverlayContainer.propTypes = {
  fieldId: PropTypes.string.isRequired,
  filters: ImmutablePropTypes.listOf(filterShape).isRequired,
  handleClose: PropTypes.func.isRequired,
  handleToggleExpandedField: PropTypes.func.isRequired,
  label: PropTypes.string,
  open: PropTypes.bool
};

export default ExpandedFiltersOverlayContainer;
